import * as React from 'react';
import { Preloader } from '@cian/valuation-component';

import * as styles from './styles.css';

interface IEstimationChartProps {
  title: React.ReactElement;
  chart: React.ReactElement;
  isDesktop: boolean;
  isLoading?: boolean;
  ref?: React.Ref<HTMLDivElement>;
}

export function EstimationChart(props: IEstimationChartProps): React.JSX.Element {
  const { title, chart, isLoading, isDesktop, ref } = props;

  return (
    <div ref={ref} data-testid="estimationChartId" className={styles['container']}>
      {isDesktop ? title : null}
      <div data-testid="chartId" className={styles['chart']}>
        {chart}
      </div>
      {isLoading && <Preloader size={32} />}
    </div>
  );
}
